<template>
  <div
    v-if="showContractByFeature"
    class="erp"
  >
    <!-- Titre Principal -->
    <v-container>
      <v-row
        noGutters
        class="erp_secondTitle"
      >
        <v-col
          cols="12"
        >
          <v-toolbar-title>
            <h1 style="font-weight: 700">
              {{ $t('sitePage.erp') }}
            </h1>
          </v-toolbar-title>
        </v-col>
      </v-row>
    </v-container>
    <!-- 1er Bloc Register -->
    <v-container class="erp_bloc1">
      <v-card
        class="vCard"
        width="100%"
      >
        <v-row
          noGutters
          class="erp_secondTitle"
        >
          <h2>
            {{ $t('forms.labels.register') }}
          </h2>
        </v-row>
        <v-row
          noGutters
          class="erp_sentenceTitle"
        >
          <span> {{ $t('erp.fillInformation') }} </span>
        </v-row>
        <v-row class="erp_bloc1_rowInput">
          <v-col
            md="4"
            cols="12"
          >
            <VTextField
              id="starting_address"
              v-model="serviceProviderUrl"
              :label="$t('erp.serviceProviderUrl') + ' *'"
              :rules="{ min: 1 }"
              placeholder="https://google.com"
              outlined
              dataCy="releaseMainTitle"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="erp_bloc1_rowButton">
            <v-btn
              color="secondary"
              @click="onSave"
            >
              {{ $t('generic.save') }}
            </v-btn>
          </v-col>
        </v-row>
        <slot name="child" />
      </v-card>
    </v-container>

    <!-- Second Bloc - Api Key Generator  -->

    <v-container class="erp_bloc2">
      <v-card
        class="vCard"
        width="100%"
      >
        <v-row
          noGutters
          class="erp_secondTitle"
        >
          <v-col>
            <h2>
              {{ $t('forms.labels.apiKeyGenerator') }}
            </h2>
          </v-col>
        </v-row>
        <v-row
          noGutters
          class="erp_sentenceTitle"
        >
          <span> {{ $t('erp.generateYourApiKey') }} </span>
        </v-row>
        <v-row>
          <v-col>
            <VTableRemote
              :iconHeader="'add'"
              :items="apiItems"
              :headers="tableHeaders"
              :itemActions="actions"
              :title="null"
              :pagination="{}"
              :loading="isLoading"
              :isSearchable="false"
              :isTableFullPage="false"
              :notSortableColumns="['name', 'description', 'status', 'apiKey', 'createdDate', 'lastUsedDate']"
              hideDefaultFooter
              isCustomIcon
              heightAuto
              @iconAction="onClickAction"
              @click-icon-header="onClickAdd"
            >
              <template v-slot:[`item.status`]="{ item }">
                <div v-if="item.isActive">
                  🟢 <span>{{ $t('erp.active') }}</span>
                </div>
                <div v-else>
                  🔴 <span>{{ $t('erp.inactive') }}</span>
                </div>
              </template>
              <template v-slot:[`item.apiKey`]="{ }">
                ********
              </template>
              <template v-slot:[`item.createdDate`]="{ item }">
                {{ $options.filters.formatDate(item.createdDate, 'L') }} <br>
                {{ $options.filters.formatDate(item.createdDate, 'LT') }}
              </template>
              <template v-slot:[`item.lastUsedDate`]="{ item }">
                {{ $options.filters.formatDate(item.lastUsedDate, 'L') }} <br>
                {{ $options.filters.formatDate(item.lastUsedDate, 'LT') }}
              </template>
            </VTableRemote>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- 3Eme Bloc - Aquassist Api Url -->

    <v-container class="erp_bloc3">
      <v-card
        class="vCard"
        width="100%"
      >
        <v-row
          noGutters
          class="erp_secondTitle"
        >
          <h2>
            {{ $t('forms.labels.aquassistApiUrl') }}
          </h2>
        </v-row>
        <v-row
          noGutters
          class="erp_sentenceTitle"
        >
          <span> {{ $t('erp.msgClickOnTheLink') }}
            <a
              :href="aquassistApiUri"
              target="_blank"
              style="color:  #0000EE;"
            >
              {{ $t('erp.here') }}
            </a>
            {{ $t('erp.msgClickOnTheLinkSuite') }}
          </span>
        </v-row>
        <v-row>
          <v-col>
            <div
              class="blocURL"
            >
              <span style="font-weight: 500">
                {{ $t('erp.msgCopyUrl') }}

              </span>

              <a
                :href="aquassistApiUri.slice(0, -12)"
                target="_blank"
                style="padding-left: 10px;"
              >
                {{ aquassistApiUri.slice(0, -12) }}
              </a>
              <v-btn
                icon
                small
                class="ml-2"
                @click="copyLink"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
  <div v-else>
    <v-container>
      <v-row
        noGutters
        class="erp_secondTitle"
      >
        <v-col
          cols="12"
        >
          <v-toolbar-title>
            <h1 style="font-weight: 700">
              {{ $t('sitePage.erp') }}
            </h1>
          </v-toolbar-title>
        </v-col>
      </v-row>
      <v-row
        noGutters
        class="erp_sentenceTitle"
      >
        <span> {{ $t('erp.featureNotActive') }} </span>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTableRemote from '@/components/shared/content-views/VTableRemote';
import ErpModal from '@/views/admin/configuration/erp/ErpModal.vue';
import Vue from 'vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm';
import ApiKeyModal from '@/views/admin/configuration/erp/ApiKeyModal.vue';

export default {
    components: {
        VTextField,
        VTableRemote,
    },
    data() {
        return {
            serviceProviderUrl: '',
            serviceProviderAPIApiKey: '',
            showApiKey: false,
            isLoading: false,
            apiItems: [],
            aquassistApiKey: null,
        };
    },
    computed: {
        ...mapGetters([
            'team',
            'teamID',
            'showContractByFeature',
        ]),
        aquassistApiUri() {
            const { VUE_APP_ENV_LABEL } = process.env;
            switch (VUE_APP_ENV_LABEL) {
                case 'PROD':
                    return 'https://erp-api.aquassist.xyz/v1/api-docs';
                case 'DEMO':
                    return 'https://erp-api-dev.aquassist.xyz/v1/api-docs';
                case 'QA':
                    return 'https://erp-api-dev.aquassist.xyz/v1/api-docs';
                case 'LOCALHOST':
                    return 'https://erp-api-dev.aquassist.xyz/v1/api-docs';
                default:
                    return null;
            }
        },
        tableHeaders() {
            return [
                'name',
                'apiKey',
                'description',
                'createdDate',
                'lastUsedDate',
                'status',
            ].map(header => ({
                text: this.$t(`forms.labels.${header}`),
                value: header,
            }));
        },
        actions() {
            const actions = [];

            actions.push({
                name: this.$t('forms.btn.edit'),
                icon: 'edit',
                mode: 'edit',
            });
            actions.push({
                name: this.$t('forms.btn.deactivate'),
                icon: 'mdi-cancel',
                mode: 'deactivate',
                customValidationProperty: 'isActive',
                showOncustomValidationProperty: true,
            });
            actions.push({
                name: this.$t('forms.btn.activate'),
                icon: 'mdi-cancel',
                mode: 'activate',
                customValidationProperty: 'isActive',
                showOncustomValidationProperty: false,
            });

            actions.push({
                name: this.$t('forms.btn.delete'),
                icon: 'delete',
                mode: 'delete',
                iconAndTextColor: '#EF4135',
            });

            return actions;
        },
    },
    async mounted() {
        await this.reloadTeam(this.teamID);
        if (this.showContractByFeature) {
            await this.getAccess();
        }
    },
    methods: {
        ...mapActions({
            reloadTeam: 'reloadTeam',
        }),
        copyLink() {
            navigator.clipboard.writeText(this.aquassistApiUri.slice(0, -12));
        },
        onClickAdd() {
            this.$root.$emit('showModal', {
                title: this.$t('erp.addApiKey'),
                component: Vue.component('AdminErpForm', ErpModal),
                payload: { isEdition: false },
                onConfirm: requestPayload => this.addAccess(requestPayload),
                isForm: false,
            });
        },
        async addAccess(requestPayload) {
            const payload = {
                ...requestPayload,
                teamId: this.team.id,
            };
            const response = await this.$rq.addAccess(payload);
            await this.getAccess();
            if (response.status === 200) {
                this.$toasted.global.toast_success({
                    message: this.$t('msg.apiKeyAdded'),
                });
            }
            if (response.data.apiKey) {
                setTimeout(() => {
                    this.$root.$emit('showModal', {
                        title: this.$t('forms.modal.quitWithoutSave.title'),
                        component: Vue.component('ApiKeyModal', ApiKeyModal),
                        payload: { apiKey: response.data.apiKey },
                        onConfirm: () => {
                            this.$root.$emit('closeModal');
                            this.getAccess();
                        },
                        isForm: false,
                    });
                }, 500);
            }
        },
        async onClickAction(item, action) {
            if (item === 'add') {
                this.onClickAdd();
            } else if (action.mode === 'edit') {
                this.$root.$emit('showModal', {
                    title: this.$t('erp.editApiKey'),
                    component: Vue.component('ErpModal', ErpModal),
                    payload: { apiItem: item, isEdition: true },
                    // eslint-disable-next-line no-underscore-dangle
                    onConfirm: requestPayload => this.onSaveEdit(item._id, requestPayload),
                    isForm: false,
                });
            } else if (action.mode === 'delete') {
                this.$root.$emit('showModal', {
                    title: this.$t('erp.deleteApiKey'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: { msg: `${this.$t('forms.modal.deleteApiKey')} ${item.name} ?` },
                    // eslint-disable-next-line no-underscore-dangle
                    onConfirm: () => this.deleteRequest(item.id || item._id),
                    isForm: false,

                });
            } else if (action.mode === 'deactivate') {
                this.$root.$emit('showModal', {
                    title: this.$t('erp.deactivateApiKey'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: { msg: `${this.$t('forms.modal.deactivateApiKey')} ${item.name} ?` },
                    // eslint-disable-next-line no-underscore-dangle
                    onConfirm: () => this.toggleActiveApiKey(action.mode, item.id || item._id),
                    isForm: false,
                });
            } else if (action.mode === 'activate') {
                this.$root.$emit('showModal', {
                    title: this.$t('erp.activateApiKey'),
                    component: Vue.component('ConfirmForm', ConfirmForm),
                    payload: { msg: `${this.$t('forms.modal.activateApiKey')} ${item.name} ?` },
                    // eslint-disable-next-line no-underscore-dangle
                    onConfirm: () => this.toggleActiveApiKey(action.mode, item.id || item._id),
                    isForm: false,
                });
            }
        },
        async getAccess() {
            const { data } = await this.$rq.getAccess(this.team.id);
            this.apiItems = data.access.aquassistApiKey;
            this.serviceProviderUrl = data.access.resource;
        },
        async deleteRequest(apiKeyId) {
            const response = await this.$rq.deleteAccess(apiKeyId, this.team.id);
            if (response.status === 200) {
                this.$toasted.global.toast_success({
                    message: this.$t('msg.apiKeyDeleted'),
                });
            }
            await this.getAccess();
        },
        async updateRequest(id, requestPayload) {
            const response = await this.$rq.updateAccess(id, requestPayload);
            if (response.status === 200) {
                this.$toasted.global.toast_success({
                    message: this.$t('msg.apiKeyInfoEdited'),
                });
            }
        },
        async toggleActiveApiKey(mode, idAccess) {
            const payload = {
                idAccess,
                teamId: this.team.id,
                status: mode,
            };

            const response = await this.$rq.toggleActivationFeature(payload);
            if (response.status === 200) {
                this.$toasted.global.toast_success({
                    message: mode === 'activate' ? this.$t('msg.apiKeyActivated') : this.$t('msg.apiKeyDeactivated'),
                });
            }
            await this.getAccess();
        },

        // save the new access
        async onSave() {
            const payload = {
                providerUrl: this.serviceProviderUrl,
                apiKey: this.serviceProviderAPIApiKey,
                teamId: this.team.id,
            };
            const response = await this.$rq.editRegisteredFeature(payload);
            if (response.status === 200) {
                this.$toasted.global.toast_success({
                    message: this.$t('msg.apiKeyRegistrationInfoEdited'),
                });
            }
            await this.getAccess();
        },
        // edit the access
        async onSaveEdit(apiKeyId, requestPayload) {
            const payload = {
                apiKeyId,
                teamId: this.team.id,
                name: requestPayload.name,
                description: requestPayload.description,
            };

            const response = await this.$rq.editAccess(payload);
            if (response.status === 200) {
                this.$toasted.global.toast_success({
                    message: this.$t('msg.apiKeyInfoEdited'),
                });
            }
            await this.getAccess();
        },
    },
};

</script>
<style lang="scss" scoped>
.api-key-container{
    margin: 20px;
}

h1 {
  font-weight: 700;
}
h2 {
  font-weight: 700;
  font-size: 1rem;
  margin-top: 10px;

}

.erp {

  &_secondTitle {
    margin-top: 20px;
  }
  &_sentenceTitle {

    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 500;

  }
  &_bloc1 {

      &_rowInput {
        display: flex;
        justify-content: space-between;
      }

      &_rowButton {
        display: flex;
        justify-content: flex-end;
      }
    }

  .vCard {
    padding-left:10px;
    padding-right:10px;
    height: auto !important;
  }
  .blocURL {
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #F5F5F5;
    width: max-content;
    padding: 40px;
    height: 50px;

    a {
      font-weight: 500;
      color: #0000EE;
    }
  }
}

.blocHeader{
  margin-left: 0 !important;
}
</style>

<!-- Enlever les marges du tablea de données pour aligner tous les contenus -->
<style lang="scss">
  .erp {
    .blocHeader {
      margin-left : 0 !important;
      margin-right: 0 !important;
    }
    .v-data-table__wrapper {
      table {
        padding-left : 0 !important;
        padding-right: 0 !important;
      }
    }
  }
</style>
